import React, { useContext } from "react"
import { Text, View } from "react-native"
import { textStyles } from "../style"
import { ThemeContext } from "../utility/context/ThemeContext"
import { useAppDispatch, useAppSelector } from '../store'
import { setUserField } from "../auth-slice"
import api from '../api-client'
import IdentityInfoForm from "../utility/forms/identity-info"
import KeyboardAvoidingScrollView from "../utility/keyboard-avoiding-scrollview"
import Analytics from "../utility/analytics"

type BasicInfoProps = {
  setStepHandler: (handler?: () => void) => void
  setNextEnabled: (enabled: boolean) => void
  loading: boolean
}

const BasicInfo: React.FC<BasicInfoProps> = ({
  setStepHandler,
  setNextEnabled,
  loading,
}: BasicInfoProps): React.ReactElement => {
  const theme = useContext(ThemeContext).theme
  const { textMain } = theme.colors

  const { user } = useAppSelector((state) => state.auth)
  const dispatch = useAppDispatch()

  return (
    <View style={{flex: 1}}>
      <KeyboardAvoidingScrollView
        extraScrollHeight={0}
        contentContainerStyle={{gap: 8}}
      >
        <Text style={[textStyles.body, {color: textMain}]}> 
          You can optionally share some identity information with us.{' '}
          While this information is not required, it helps us better understand{' '}
          the community we serve.
        </Text>
        <IdentityInfoForm
          needsModification={false}
          onValidationSuccess={(handleSubmit) => {
            setNextEnabled(true)
            setStepHandler(handleSubmit)
          }}
          onValidationFailure={() => {
            setStepHandler(undefined)
            setNextEnabled(false)
          }}
          loading={loading}
          onSubmit={(values) => {
            dispatch(setUserField({
              field: "identityInfo",
              value: {
                ...user.identityInfo,
                ...values,
                genderDescription: values.gender === "Other (Please Specify)" ? values.genderDescription : "",
                sexualOrientationDescription: values.sexualOrientation === "Other (Please Specify)" ? values.sexualOrientationDescription : "",
              }
            }))

            api.updateUser({
              identityInfo: {
                ...user.identityInfo,
                ...values,
                genderDescription: values.gender === "Other (Please Specify)" ? values.genderDescription : "",
                sexualOrientationDescription: values.sexualOrientation === "Other (Please Specify)" ? values.sexualOrientationDescription : "",
              }
            })
            Analytics.track('update_demographics_submitted', {
              success: true,
            })
          }}
        />
      </KeyboardAvoidingScrollView>
      
    </View>
  )
}

export default BasicInfo